module.exports = Em.Service.extend
  env: Em.inject.service('environment')

  initiateDialogue: (content='') ->
    if @get('env.intercomEnabled')
      Intercom('showNewMessage', content)
    else
      App.__container__.lookup('controller:application').send('showSupportModal', arguments...)
